
  import { defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';
  import { IndicesType } from '@/store/enums/TypeOfIndicesEnums';

  export default defineComponent({
    name: 'testimonials-creating',
    components: {
      ErrorMessage,
      Field,
      Form,
    },
    setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const thumbnail = ref('/media/avatars/blank-image.jpg');
      let file;
      const { can } = useAbility();
      const selectedType = ref<string>('');

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      const previewImage = (e) => {
        file = e.target.files[0];
        thumbnail.value = URL.createObjectURL(file);
      };

      const validationSchema = Yup.object().shape({
        blogId: Yup.number().nullable().label('Blog ID'),
        nameEn: Yup.string()
          .required(() => translate('EN_NAME_IS_REQUIRED_FIELD'))
          .label('English Name'),
        nameAr: Yup.string()
          .required(() => translate('AR_NAME_IS_REQUIRED_FIELD'))
          .label('Arabic Name'),
        contentEn: Yup.string()
          .required(() => translate('EN_CONTENT_IS_REQUIRED_FIELD'))
          .label('English Content'),
        contentAr: Yup.string()
          .required(() => translate('AR_CONTENT_IS_REQUIRED_FIELD'))
          .label('Arabic Content'),
        avatar: Yup.string().nullable().label('Avatar'),
        likesCount: Yup.number().nullable().label('Likes Count'),
        okayCount: Yup.number().nullable().label('Views Count'),
        publishDate: Yup.date().nullable().label('Publish Date'),
        referenceLink: Yup.string().url().nullable().label('Reference Link'),
        type: Yup.number()
          .required(() => translate('TYPE_OF_INDEX_IS_REQUIRED_FIELD'))
          .label('Type of Index'),
      });

      const onSubmitCreate = async (values) => {
        delete values.avatar;
        if (submitButton.value) {
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }

        if (values.publishDate)
          values.publishDate = new Date(values.publishDate);

        const payload = {
          ...values,
          likesCount: values.likesCount || 0,
          okayCount: values.okayCount || 0,
        };

        debugger;
        const createTestimonial = await store.dispatch(
          Actions.CREATE_TESTIMONIAL,
          payload
        );
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        const logoFormData = new FormData();
        // eslint-disable-next-line
        logoFormData.append('logo', file);

        debugger;
        console.log('File:', file);
        console.log('ID:', createTestimonial.id);

        if (file && createTestimonial?.id) {
          const logoFormData = new FormData();
          logoFormData.append('logo', file);

          await store.dispatch(Actions.UPLOAD_TESTIMONIAL_AVATAR, {
            data: logoFormData,
            id: createTestimonial.id,
          });
        }

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          submitButton.value?.removeAttribute('data-kt-indicator');
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_CREATED_TESTIMONIAL'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'testimonials-listing' });
          });
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('testimonialsCreating'), [
          translate('indices'),
        ]);
      });

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        onSubmitCreate,
        submitButton,
        translate,
        validationSchema,
        goBack,
        can,
        previewImage,
        file,
        thumbnail,
        IndicesType,
        selectedType,
      };
    },
  });
